import React, { useState } from "react";
import styles from "../../style/traveltabform.module.scss";

const TravelTabForm: React.FC = () => {
  const [activeTab, setActiveTab] = useState<
    "flights" | "deals" | "agents" | "cabs" | "hotels"
  >("flights");

  return (
    <div className={styles.travelContainer}>
      <div className={styles.tabHeader}>
        <button
          className={activeTab === "flights" ? styles.active : ""}
          onClick={() => setActiveTab("flights")}
        >
          Flights
        </button>
        <button
          className={activeTab === "deals" ? styles.active : ""}
          onClick={() => setActiveTab("deals")}
        >
          Deals
        </button>
        <button
          className={activeTab === "agents" ? styles.active : ""}
          onClick={() => setActiveTab("agents")}
        >
          Travel Agents
        </button>
        <button
          className={activeTab === "cabs" ? styles.active : ""}
          onClick={() => setActiveTab("cabs")}
        >
          Cabs
        </button>
        <button
          className={activeTab === "hotels" ? styles.active : ""}
          onClick={() => setActiveTab("hotels")}
        >
          Hotels
        </button>
      </div>

      <div className={styles.tabContent}>
        {activeTab === "flights" && (
          <form className={styles.form}>
            <div className={styles.formRow}>
              <input type="text" placeholder="From (City / Airport)" />
              <input type="text" placeholder="To (City / Airport)" />
              <input type="date" />
              <input type="date" />
              <button>Search Flights</button>
            </div>
          </form>
        )}

        {activeTab === "deals" && (
          <form className={styles.form}>
            <div className={styles.formRow}>
              <input type="text" placeholder="City or Airport" />
              <select>
                <option value="flights">Flight Deals</option>
                <option value="hotels">Hotel Deals</option>
              </select>
              <input type="date" />
              <button>Find Deals</button>
            </div>
          </form>
        )}

        {activeTab === "agents" && (
          <form className={styles.form}>
            <div className={styles.formRow}>
              <input type="text" placeholder="Your City" />
              <input type="text" placeholder="Preferred Destination" />
              <input type="tel" placeholder="Contact Number" />
              <button>Search Agents</button>
            </div>
          </form>
        )}

        {activeTab === "cabs" && (
          <form className={styles.form}>
            <div className={styles.formRow}>
              <input type="text" placeholder="From (City / Airport)" />
              <input type="text" placeholder="To (City / Airport)" />
              <input type="date" />
              <button>Search Cabs</button>
            </div>
          </form>
        )}

        {activeTab === "hotels" && (
          <form className={styles.form}>
            <div className={styles.formRow}>
              <input type="text" placeholder="City or Location" />
              <input type="date" />
              <input type="date" />
              <button>Search Hotels</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default TravelTabForm;
